export const DISPLAY_FORMATS = {
  DEFAULT: 'slideshow',
  SLIDESHOW: 'slideshow',
  LIST: 'list',
}

export const ANIMATION_DURATION = 600
